export class Industry {
    constructor(
        public code: string,
        public name: string
    ) { }
}